import { sendData } from "../../../services/sendData";

export const saveCustomerRecordFields = (data: string[], logoutAction: any) => {
  sendData({
    endPoint: "saveRecordFields",
    payload: { data },
    logoutAction,
  });
};
